<template>
  <div class="fillcontain">
    <search-item @showDialog="showAddAppointmenttypeDialog"></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
        @select="selectTable"
        @select-all="selectAll"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          width="100"
          prop="id"
          label="id"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="预约类型名称"
          align="center"
        ></el-table-column>
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditAppointmenttype(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="delete"
              size="mini"
              @click="onDeleteAppointmenttype(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addAppointmenttypeDialog.show"
        :isShow="addAppointmenttypeDialog.show"
        :dialogRow="addAppointmenttypeDialog.dialogRow"
        @getAppointmenttypeList="getAppointmentList"
        @closeDialog="hideAddFundDialog"
      ></addFundDialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addCourseDialog";
import Pagination from "@/components/pagination";
import { myTime, formatDateTime, formatDateTime1 } from "../../utils/date.js";
import {
  getAppointmenttypes,
  deleteAppointmenttype,
} from "@/api/appointmenttype";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  data() {
    return {
      tableData: [],
      tableHeight: 0,
      loading: false,
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      multipleSelection: [], //多选的数据
      sortnum: 0,
      addAppointmenttypeDialog: {
        show: false,
        dialogRow: {},
      },
      courseData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {},
    };
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
    filterTime1(time) {
      var dd = myTime(time);
      return formatDateTime1(dd);
    },
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["courseSearch"]),
  },
  mounted() {
    this.getAppointmentList();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    //获取预约类型列表
    getAppointmentList() {
      const para = this.courseData;
      getAppointmenttypes(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.totalSize;
        this.tableData = res.data.data.data;
      });
    },
    // 显示添加预约类型弹窗
    showAddAppointmenttypeDialog(val) {
      this.$store.commit("SET_APPOINTMENTTYPE_DIALOG_TITLE", val);
      this.addAppointmenttypeDialog.show = true;
    },
    hideAddFundDialog() {
      this.addAppointmenttypeDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.courseData.page = val;
      this.getAppointmentList();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.courseData.limit = val;
      this.getAppointmentList();
    },
    // 编辑操作方法
    onEditAppointmenttype(row) {
      console.log(row);
      var param = Object.assign({}, row);
      this.addAppointmenttypeDialog.dialogRow = {
        param,
      };
      this.showAddAppointmenttypeDialog();
    },
    // 删除数据
    onDeleteAppointmenttype(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteAppointmenttype(row.id).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            // 删除成功后添加操作记录
            const para = {
              userName: getToken("USERNAME"),
              content: "删除(" + row.type + ")预约类型操作",
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.getAppointmentList();
          });
        })
        .catch(() => {});
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
    setSearchBtn(val) {
      let isFlag = true;
      if (val.length > 0) {
        isFlag = false;
      } else {
        isFlag = true;
      }
      this.$store.commit("SET_COURSE_SEARCHBTN_DISABLED", isFlag);
    },
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>


